var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',[_c('Col',{attrs:{"span":"24"}},[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.TableData,"maxHeight":500}})],1),_vm._v(" "),_c('Row',[_c('Col',{attrs:{"span":"24"}},[_c('Page',{staticClass:"page",attrs:{"total":_vm.TableTotal,"show-elevator":"","show-sizer":""},on:{"on-change":_vm.changeNumber,"on-page-size-change":_vm.changeSize}})],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f03d8fd0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CultivatedLandComponent/Table.vue
// module id = null
// module chunks = 